import { cn } from '~/shadcn/lib/utils'

type Props = {
  children: React.ReactNode
  className?: string
}
function InvestmentAttributeLabel({ children, className }: Props) {
  return (
    <span
      className={cn(
        'flex items-center uppercase text-[13px] min-h-8 font-semibold self-center',
        className
      )}>
      {children}
    </span>
  )
}

export { InvestmentAttributeLabel }
